import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Certificate = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 4H9C6.237 4 4 6.237 4 9V19C4 21.762 6.237 24 9 24H10V27C10 27.55 10.45 28 11 28C11.325 28 11.613 27.837 11.8 27.6L14 24.662L16.2 27.6C16.388 27.838 16.675 28 17 28C17.55 28 18 27.55 18 27V24H23C25.762 24 28 21.762 28 19V9C28 6.237 25.762 4 23 4ZM14 22C13.687 22 13.387 22.15 13.2 22.4L12 24V19.65C12.625 19.875 13.3 20 14 20C14.7 20 15.375 19.875 16 19.65V24L14.8 22.4C14.612 22.15 14.312 22 14 22ZM14 18C11.8 18 10 16.2 10 14C10 11.8 11.8 10 14 10C16.2 10 18 11.8 18 14C18 16.2 16.2 18 14 18ZM26 19C26 20.65 24.65 22 23 22H18V18.462C19.225 17.362 20 15.762 20 13.999C20 10.686 17.312 7.999 14 7.999C10.688 7.999 8 10.687 8 13.999C8 15.774 8.775 17.361 10 18.462V22H9C7.35 22 6 20.65 6 19V9C6 7.35 7.35 6 9 6H23C24.65 6 26 7.35 26 9V19Z" />
	</svg>
);

export default Certificate;
